<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data v-else :references.sync="formReferences" :model="modelObj" ref="systemConfigReference">
       <template slot="extraDetails">
        <v-container fluid>
          <v-layout wrap class="">
          <v-flex lg12 xs12>
            <p>{{$t('message.systemConfiguration.ticketCreation')}}</p>
            <ckeditor :editor="editor" v-model="modelObj.ticket_creation_response" :config="editorConfig" ref="editor"></ckeditor>
          </v-flex>
          </v-layout>
        </v-container>
      </template>
    </form-data>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '../../components/FormTemplate'
import Editor from '@/ckeditor'
export default {
  data () {
    return {
      modelObj: {},
      fieldsLoading: false,
      loading: false,
      MODULE_URL: 'systemconfigurations',
      editor: Editor,
      editorConfig: {
        removePlugins: [ 'ImageUpload' ]
      }
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE']),
    formReferences () {
      return {
        title: this.$t('message.systemConfiguration.systemConfig'),
        properties: [{
          model: 'ticketterm',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.systemConfiguration.ticketterm'),
          class: 'lg3 sm6'
        }, {
          model: 'syncinterval',
          type: this.FORM_TYPE.NUMBER,
          rules: [],
          label: this.$t('message.systemConfiguration.syncinterval'),
          class: 'lg3 sm6'
        }],
        buttons: [{
          name: 'save_update_action',
          color: 'success',
          label: this.$t('message.common.save'), // this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveSystemConfiguration(this.SAVE),
          loading: this.loading,
          is_show: true
        }]
      }
    }
  },
  mounted () {
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.$router.push('ticketing_configuration')
      }
    })
    this.getSystemConfiguration()
    if (this.modelObj.id) this.getSingleRecordHandler()
  },
  methods: {
    getSystemConfiguration () {
      this.fieldsLoading = true
      this.$_executeApi('get', `systemconfigurations`)
        .then((response) => {
          this.modelObj = response.data
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveSystemConfiguration () {
      if (this.$refs.systemConfigReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.modelObj
        this.$_executeApi('post', `${this.MODULE_URL}`, model)
          .then((response) => {
            this.modelObj = response.data
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    saveUpdateHandler (type) {
      if (this.$refs.systemConfigReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.modelObj
        let url = this.MODULE_URL
        this.$_saveUpdateHandler(url, model)
          .then((response) => {
            if (type === this.SAVE) this.$router.push(`/${this.MODULE_URL}/actions/${response.id}`)
            else if (type === this.UPDATE_CLOSE) this.$router.push(this.MODULE_URL)
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },

    supportingList (type, text) {
      const modelName = text
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
<style>
.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
